<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 11" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="currencyObj" ref="currencyReference">
    </form-data>
    <v-expansion-panels class="my-3" v-if="this.currencyObj.id" v-model="openPanel">
      <v-expansion-panel>
        <v-expansion-panel-header> {{ $t('message.orders.history') }}
          <template v-slot:actions>
              <v-icon color="black"> mdi-menu-down </v-icon>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th> {{ $t('message.document.datecreated') }} </th>
                <th> {{ $t('message.currency.exchangeRate') }} </th>
                <th> {{ $t('message.currency.validFrom') }} </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in currencyRateHistories"
                :key="item.id"
              >
                <td>{{ item.createdat }}</td>
                <td>{{ item.exchangerate }}</td>
                <td>{{ item.validfrom }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      currencyObj: {
        id: this.$route.params.currency_id,
        isactive: false
      },
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'currencies',
      listOfCurrencyList: [],
      currencyRateHistories: [],
      openPanel: 0
    }
  },
  components: {
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfCurrency']),
    formReferences () {
      return {
        title: this.$route.params.currency_id ? this.$t('message.currency.updateCurrency') : this.$t('message.currency.addCurrency'),
        properties: [{
          model: 'currencyid',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.product.currency'),
          items: this.listOfCurrencyList,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6'
        }, {
          model: 'exchangerate',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.currency.exchangeRate'),
          class: 'lg2 sm6'
        }, {
          model: 'validfrom',
          type: this.FORM_TYPE.DATEPICKER,
          rules: this.$_requiredValidation,
          picker: 'datePicker',
          menu: 'dateMenu',
          label: this.$t('message.currency.validFrom'),
          class: 'lg3 sm6 xs12',
          color: 'primary lighten-1'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.currency_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'close_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.currency_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          to: `/${this.MODULE_URL}`,
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          is_show: this.$route.params.currency_id
        }]
      }
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === this.MODULE_URL) {
        this.$router.push(this.MODULE_URL)
      }
    })
    if (this.currencyObj.id) {
      this.getSingleRecordHandler()
    } else this.currencyObj.isactive = true
    this.getAllCurrencyList()
  },
  watch: {
    'currencyObj.datePicker' (val) {
      if (val) {
        this.currencyObj.validfrom = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    }
  },
  methods: {
    getAllCurrencyList () {
      this.$_executeApi('get', `currencies/get_all_currency_list`)
        .then((response) => {
          this.listOfCurrencyList = response.data
        })
    },
    getCurrencyRateHistories (currencyModel) {
      this.$_executeApi('get', `currencies/get_histories/${currencyModel.id}/${currencyModel.currencyid}`)
        .then((response) => {
          if (response.data) {
            const transformData = { number: { list: ['exchangerate'], format: 'replaceDotWithComma' }, date: { list: ['validfrom', 'createdat'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
            this.currencyRateHistories = this.$_formatListModel(response.data, transformData)
          }
        })
    },
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.currencyObj }, { [prop]: item.id })
        this.currencyObj = model
      }
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.currencyObj.id}`)
        .then((result) => {
          if (result.data) {
            let currency = result.data
            let transformData = { number: { list: ['exchangerate'], format: 'replaceDotWithComma' }, date: { list: ['validfrom'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
            let model = this.$_formatModel(currency, transformData)
            this.currencyObj = model
            this.getCurrencyRateHistories(result.data)
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.currencyReference.$refs.validateForm.validate()) {
        this.loading = true
        let transformData = { date: { list: ['validfrom'], from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' }, number: { list: ['exchangerate'], format: 'replaceCommaWithDot' } }
        let model = this.$_formatModel(this.currencyObj, transformData)
        this.$_saveUpdateHandler(this.MODULE_URL, model)
          .then((response) => {
            if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
            else if (type === this.SAVE && model.id) {
              this.getSingleRecordHandler()
            } else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteHandler () {
      let ids = [this.currencyObj.id]
      let payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
